export default "__VITE_ASSET__Q1$9gmEG__"